import { render, staticRenderFns } from "./RequiredNutrientDetails.vue?vue&type=template&id=201a8136&scoped=true&"
import script from "./RequiredNutrientDetails.vue?vue&type=script&lang=js&"
export * from "./RequiredNutrientDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201a8136",
  null
  
)

export default component.exports